import React from 'react';
import { StyledBackButton, StyledBackButtonText } from './BackButton.styles';
import { useRouter } from 'next/router';
import { SIZE } from 'app/ui-components/typography/PlayText/PlayText';

const BackButton = () => {
    const router = useRouter();

    const handleBack = () => {
        // `state.idx` seems to be the length of the local history stack.
        // It's however undocumented so this may break in the future ¯\_(ツ)_/¯
        if (window.history.state && window.history.state.idx > 0) {
            router.back();
        } else {
            const { titleSlug, episodeSlug, videoId, slug } = router.query;

            if (!titleSlug) {
                router.push({ pathname: router.pathname, query: { videoId, slug } });
            } else {
                router.push({ pathname: router.pathname, query: { titleSlug, episodeSlug, videoId } });
            }
        }
    };

    return (
        <StyledBackButton role="button" aria-label="Stäng videospelaren" onClick={handleBack}>
            <StyledBackButtonText size={SIZE.MINI}>Tillbaka</StyledBackButtonText>
        </StyledBackButton>
    );
};

export default BackButton;
